import axiosInstance from "../axios/models/axiosInstance"
import { userAction } from "../components/store/actions/userAction"
import {
  REDUX_CUSTOMER_DEFAULTS,
  REDUX_STORE_DEFAULTS,
} from "../components/store/config"
import store from "../components/store/Store"

let eventSource = null
let listeners = new Set()

const SSE_URL = axiosInstance.getUri() + "sse/subscribe"
// const SSE_URL = "https://sys.boostceramic.ca/api/v3/sse/subscribe"

export function connectSSE(token) {
  if (eventSource) {
    console.log("⚠️ SSE already connected")
    store.dispatch(
      userAction(REDUX_STORE_DEFAULTS.UPDATE_SSE_CONNECTION(), true),
    )
    return
  }

  const url = `${SSE_URL}?token=${token}`

  eventSource = new EventSource(url, {
    withCredentials: true,
  })

  eventSource.onopen = () => {
    console.log("🟢 SSE connected")
    store.dispatch(
      userAction(REDUX_STORE_DEFAULTS.UPDATE_SSE_CONNECTION(), true),
    )
  }

  eventSource.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data)
      //   console.log("📩 SSE message:", data)

      listeners.forEach((cb) => cb(data))
    } catch (err) {
      console.error("❌ SSE parse error", err)
    }
  }

  eventSource.onerror = (err) => {
    console.warn("⚠️ SSE error (browser will retry automatically)", err)
    store.dispatch(
      userAction(REDUX_STORE_DEFAULTS.UPDATE_SSE_CONNECTION(), false),
    )
    // disconnectSSE()
  }
}

export function disconnectSSE() {
  if (eventSource) {
    eventSource.close()
    eventSource = null
    listeners.clear()
    console.log("🔌 SSE disconnected")
    store.dispatch(
      userAction(REDUX_STORE_DEFAULTS.UPDATE_SSE_CONNECTION(), false),
    )
  }
}

export function addSSEListener(callback) {
  listeners.add(callback)
  return () => listeners.delete(callback)
}
